import { render, staticRenderFns } from "./articlemanagedetail.vue?vue&type=template&id=1353fa3c&scoped=true&"
import script from "./articlemanagedetail.vue?vue&type=script&lang=js&"
export * from "./articlemanagedetail.vue?vue&type=script&lang=js&"
import style0 from "./articlemanagedetail.vue?vue&type=style&index=0&id=1353fa3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353fa3c",
  null
  
)

component.options.__file = "articlemanagedetail.vue"
export default component.exports